import React, { useEffect, useState } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar, Label } from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";

export const BrandElement = (props) => {
	return (
		<div className={`brandElement-component ${props.className}`}>
			<div>
				<div>
					<p className="lead">{props.title}</p>
					<p>{props.desc}</p>
					{props.unpublishedData?.[props.path] && (
						<Label
							shapeStyle="fill"
							text={
								<Translate value="app-brand-modal-tabs-label-unpublished" />
							}
						/>
					)}
				</div>
			</div>
			<div>
				<div>{props.rightPanel}</div>
			</div>
		</div>
	);
};

BrandElement.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	desc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	rightPanel: PropTypes.any,
	unpublishedData: PropTypes.object,
	path: PropTypes.string,
	className: PropTypes.string,
};

BrandElement.defaultProps = {
	className: "",
};

export default withRouter(
	connect(
		(state) => {
			return {
				unpublishedData: state.localBrand.unpublishedData,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(BrandElement)
);
